/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VerifyUnipassPersonResVo
 */
export interface VerifyUnipassPersonResVo {
    /**
     * 个人通关号
     * @type {string}
     * @memberof VerifyUnipassPersonResVo
     */
    persEcm?: string;
    /**
     * 验证结果 1为成功, 0为失败
     * @type {string}
     * @memberof VerifyUnipassPersonResVo
     */
    tCnt?: string;
    /**
     * 有效期开始时间
     * @type {string}
     * @memberof VerifyUnipassPersonResVo
     */
    valtPridStrtDt?: string;
    /**
     * 有效期结束时间
     * @type {string}
     * @memberof VerifyUnipassPersonResVo
     */
    valtPridXpirDt?: string;
    /**
     * 校验失败信息
     * @type {string}
     * @memberof VerifyUnipassPersonResVo
     */
    errMsgCn?: string;
}

/**
 * Check if a given object implements the VerifyUnipassPersonResVo interface.
 */
export function instanceOfVerifyUnipassPersonResVo(value: object): value is VerifyUnipassPersonResVo {
    return true;
}

export function VerifyUnipassPersonResVoFromJSON(json: any): VerifyUnipassPersonResVo {
    return VerifyUnipassPersonResVoFromJSONTyped(json, false);
}

export function VerifyUnipassPersonResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): VerifyUnipassPersonResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'persEcm': json['persEcm'] == null ? undefined : json['persEcm'],
        'tCnt': json['tCnt'] == null ? undefined : json['tCnt'],
        'valtPridStrtDt': json['valtPridStrtDt'] == null ? undefined : json['valtPridStrtDt'],
        'valtPridXpirDt': json['valtPridXpirDt'] == null ? undefined : json['valtPridXpirDt'],
        'errMsgCn': json['errMsgCn'] == null ? undefined : json['errMsgCn'],
    };
}

export function VerifyUnipassPersonResVoToJSON(json: any): VerifyUnipassPersonResVo {
    return VerifyUnipassPersonResVoToJSONTyped(json, false);
}

export function VerifyUnipassPersonResVoToJSONTyped(value?: VerifyUnipassPersonResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'persEcm': value['persEcm'],
        'tCnt': value['tCnt'],
        'valtPridStrtDt': value['valtPridStrtDt'],
        'valtPridXpirDt': value['valtPridXpirDt'],
        'errMsgCn': value['errMsgCn'],
    };
}

